export default {
  nav: {
    about: "关于我们",
    laboratory: "实验室",
    product: "产品",
    report: "报告",
    contact: "联系我们",
  },
  names: "中文(CN)",
  Home: {
    health: "男性健康专家，守护您的生殖健康",
    product:
      "深耕前列腺、睾丸、膀胱及肾脏肿瘤临床与科研工作，重点攻克勃起功能障碍、男性性功能衰退相关难题；牵头开展全球多中心性功能康复临床试验，系统阐释男性勃起功能障碍、性功能保护与康复干预方案之间的关联机制。作为全球为数不多同时精通泌尿生殖肿瘤与男性生殖健康领域的权威学者，其研究成果现已成为全球范围内改善男性勃起功能障碍、恢复男性性功能的核心临床参照标准。",
    about: "卡里姆・菲扎齐",
    span: "教授",
    authority:
      "他在法国格鲁索斯研究所和巴黎圣克利大学教授性功能康复临床试验，是国际男性勃起功能障碍和男性性功能领域的权威学者。",
    ss: "您正在找什么？",
    States: "美国ECOSUPER生态技术生命科学研究所",
    researchLab:
      "ECOSUPER 全称美国超级生态生命科学研究院，创立于 2016 年，隶属于美国超级生态科技公司，是其旗下全球核心科研机构，总部坐落于美国科罗拉多州首府丹佛市。研究院自成立以来，汇聚全球数十位生物医学、病理学、遗传学、计算机科学、生物医学数据科学等领域权威学者，组建起一支跨学科、高层次专业科研团队。",
    leadership:
      "研究院由斯坦福大学首席研发专家斯蒂芬教授领衔主持工作，先后设立亚太研发中心（中国香港）、欧洲研发中心（德国）、南非科研中心（约翰内斯堡），搭建起覆盖全球各大核心区域的科研网络。秉持探索生命科技、洞悉自然本源的核心研发理念，深耕人体机理与天然食物奥秘交叉学科领域，斩获多项具备国际影响力的科研成果。",
    same: "与此同时，研究院与全球多家顶尖医学研发机构搭建深度跨境技术协作与科研成果共享体系，打造集全球研发、全球采购、全球量产于一体的全链条科研成果转化能力。依托引领时代的前沿超级生态技术，持续为人类生命健康事业输出可持续创新力量。",
    Team: "R&D科学家团队",
    Stephen: "斯蒂芬·蒙哥马利",
    li: "美国ECOSUPER生态技术生命科学研究所教授",
    li1: "斯坦福大学医学学院教授",
    li2: "病理学教授",
    li3: "遗传学教授",
    li4: "生物医学数据科学教授",
    direction: "主要研究方向：",
    research: "使用基因组学方法研究基因变异如何影响基因表达和疾病。",
    directions: "荣誉成就：",
    achiev:
      "2019年美国基因组学学会（ASHG）颁发的早期职业生涯奖，领导多个大规模全国项目，如GTEx和MoTrPAC。",
    introduction: "R&D团队成员和介绍",
    Professor: "卡里姆・菲扎齐",
    Professor1: "阿瑟・伯内特 医学博士",
    Professor2: "许伟彦 医学博士",
    Professor3: "基安・阿萨纳德 医学博士",
    Professor4: "戴维・斯克里特 - 伯恩 博士",
    Professor5: "古川阳一 教授",
    medical:
      "他在法国格鲁索斯研究所和巴黎圣克利大学教授性功能康复临床试验，是国际男性勃起功能障碍和男性性功能领域的权威学者。",
    medical1:
      "约翰・霍普金斯大学医学院泌尿外科教授、神经泌尿基础科学实验室主任。她是勃起功能障碍科研与临床医学领域的世界级权威学者，率先发现了勃起组织内一氧化氮的生化作用机制。",
    medical2:
      "莱佛士医院泌尿外科高级顾问医师；新加坡国立大学医学学士；英国爱丁堡皇家外科学院院士",
    medical3:
      "南加州大学凯克医学院临床泌尿外科学助理教授，专攻男性泌尿外科、男性不育症及生殖显微外科。擅长勃起功能障碍假体植入手术、佩罗尼氏病阴茎复杂重建术与泌尿外科微创手术。",
    medical4:
      "慕尼黑亥姆霍兹实验遗传学研究所博士后研究员，主攻男性生殖生物学方向。其研究致力于阐明可育男性与不育男性精子的分子调控机制，以及环境应激信号如何通过精子表观遗传途径传递至子代。",
    medical5:
      "（古川阳一教授）—— 医学博士、哲学博士，东京大学医科学研究所应用基因组学部门主任；研究领域涵盖分子生物学、临床遗传学与医学基因组学。",
    institutions: "合作研究和开发机构",
    achievements: "核心技术成就",
    milestone: "R&D里程碑",
    vements:
      "美国ECOSUPER生态技术生命科学研究所，基于2019年诺贝尔医学奖研究结果，发现了天然食物成分中10X的超能力肽的存在。",
    vements1:
      "十倍超肽精粹，可养护男性勃起相关 MDM4 基因关键片段，滋养性腺受体细胞，循序渐进调理身体，改善男性精力不佳、房事乏力等亚健康状态，帮助提升自身生理状态。",
    vements2:
      "纯天然食材配方，彻底摆脱化学合成药物给人体脏器带来的损伤，循序渐进自然修护男性各项受损生理机能，无需长期服药，杜绝药物依赖。",
    Based:
      "依托2019年诺贝尔医学奖最新科研成果，美国ECOSUPER生命科学研究院在天然食材中发现了超能肽10X物质。",
    Significant:
      "取得重大科研突破：研究团队依托海量实验数据结合人工智能反复交叉验证，最终证实MDM4调控p53活性紊乱是男性勃起功能障碍发病的核心诱因，权重高达85%，该结论填补了国际相关领域理论空白。",
    How: "修复男性勃起调节机制成为攻克勃起障碍的关键，美国超级生态生命科学研究院联合全球多家科研机构，启动跨国联合研发项目。",
    Through:
      "历经全球上万种天然食材精粹层层筛选、反复测试，成功找到可精准修复MDM4基因表达与性腺受体机能的天然核心活性物质，并将其首次命名为SUPER Peptide-10X超能肽。",
    Over: "历经8年潜心研发，美国超级生态科技公司率先打造出全球新一代全天然食材配方男士健康产品，彻底告别依靠化学药物提升男性机能的时代。",
  },
  setting: {
    Peptides:'肽成分焕活男性生理机能，深层滋养，稳固生理健康状态。',
    Vitality: "男性活力全球科研成果黄金标杆",
    market:
      "现代男性长期承压、作息紊乱，身体机能持续耗损；传统滋补品吸收效率低、作用周期短暂，难以满足当代男性日常养护需求。",
    contemporary:
      "美国ECOSUPER生命科学研究院整合法、日、德等多国顶尖实验室资源，历经8年专项科研打磨，重磅推出十倍超肽精粹SUPER Super Peptide -X10。甄选全球珍稀天然精粹原料，搭载多国专利生物萃取技术，重新定义男性强健标准，现已全面登陆东南亚市场。",
    Men: "男性强健标准",
    Fullness: "充盈度",
    Support: "支撑力",
    Endurance: "持久力",
    Firm: "饱满紧实，肌理充盈",
    Straight: "可呈90°挺立，稳固强劲",
    Base: "基础续航时长可达30分钟以上",
    Works: "工作时间可达12小时以上",
    time: "1. 靶向基因激活 · 长久维持勃起巅峰状态",
    Peptide: "2. 专利低温酶解 · 小分子直吸活性肽",
    effects: "3. 全球甄选配方 | 即时起效+长效滋养双重协同",
    Standards: "4. 全球溯源管控——制药级安全标准",
    erection:
      "精准作用于性腺受体以及MDM4勃起关键基因，快速唤醒身体原生机能；同时增强充血反应、提升耐受阈值，快速达到巅峰硬度，实现坚挺、持久勃起状态。",
    hydrolysis:
      "运用分段式低温低压酶解技术，将大分子蛋白质切割为分子量≤800道尔顿的超短链肽。无需在肠胃中二次分解，可直接进入血液循环，为性腺细胞修复输送高活性营养。",
    production:
      "甄选法国、日本、俄罗斯、中国四大原料产区原料，3种珍稀海洋活性肽搭配5种珍贵植物精粹，打造即时调理+长效养护双效体系，满足男性即时需求与长期身体调养所需。",
    traceability:
      "所有原料搭建全球「一物一码」溯源体系；十万级恒温无菌制药级车间生产。不含外源激素，无刺激性化学添加剂。",
    oyster: "1. 法国大西洋深海牡蛎肽",
    fish: "2. 安第斯高原有机玛卡粉",
    plant: "3. 日本北海道深海海参肽",
    animal:
      "快速充盈阴茎海绵体血管，加快充血速率，改善勃起绵软问题，高效提升充盈度与坚挺质感。",
    blood:
      "双向调节男性内源性激素分泌，平衡全身生理机能，改善生理欲望低迷状态。",
    secretion: "修护受损性腺受体，强化勃起支撑力，稳固90°挺立的健康状态。",
    enhance: "全球珍稀精粹 一粒浓缩全营养",
    Natural: "天然调养 · 温和安全 · 无依赖、不反弹",
    Rebound:
      "美国ECOSUPER生命科学研究院历经8年潜心研发，依托诺贝尔奖p53调控通路理论，联合全球七大顶尖医疗机构，甄选世界各地珍稀原料，萃取核心活性十倍超肽精粹SUPER Peptide-10X。成分可靶向滋养修护MDM4机能基因、充盈海绵体细胞，从根源改善勃起疲软、勃起时长不足等男性亚健康问题，不损伤生殖器官；长期调养不会产生身体依赖，停用后状态稳定无回落反弹。",
    dedicated: "三大活性肽精粹",
    Active: "唤醒身体原生核心活力",
    Extracts: "五大核心植物精粹",
    Stamina: "维系巅峰体能状态",
    Russia: "1. 俄罗斯西伯利亚树莓",
    China: "2. 中国怀庆府黄精",
    Yam: "3. 中国铁棍山药粉",
    Gorgon: "4. 中国江南红果",
    Poria: "5. 云南茯苓",
    Stabilize: "调节内分泌稳定，降低身体敏感阈值，改善早泄问题、提升身体耐力",
    Replenish: "充盈元气精力，舒缓体虚乏力以及事后疲惫倦怠感",
    Erect: "调养呵护肠胃，中和海洋肽类寒凉属性，稳固坚挺状态",
    duration: "调理腺体机能，提升自身把控力，有效延长体能续航时长",
    Long: "长期调养可稳固身体机能，强健体魄状态能够长久维系",
    Performance: "唤醒原生性腺活力 · 解锁强劲巅峰状态",
    provide:
      "普通滋补品仅能实现表层滋养，作用短暂且收效微弱。SUPER十倍超肽精粹X10兼具即时体能提升与长效细胞修护双重作用，全周期稳固身体状态；可快速收获强劲挺立质感，即刻拥有饱满紧实的坚挺表现。",
    strength: "1. 基因焕活 · 即刻迸发体能",
    regain: "2. 调和内在机能 · 重拾充沛元气",
    roots: "3. 草本固本 · 随心维系强健状态",
    directly:
      "三重800道尔顿小分子肽可直接入血，修护MDM4机能基因、滋养充盈性腺受体，快速唤醒坚挺状态，自主把控硬度质感。",
    eliminate:
      "树莓多酚清除体内自由基，修护生殖相关基因，改善体虚乏力、失眠、精力匮乏问题，重塑男性强健体魄。",
    poria:
      "玉竹、山药、薏苡仁、茯苓调和肽类寒凉属性，深层滋补固本，长效调养身体，时刻维持舒适强健状态。",
    confidence: "第1天：肌体即刻焕活 · 重拾身心自信",
    Prolonged: "2周：体能稳步提升 · 活力长效续航",
    Retention: "4周：巅峰健康状态 · 调养效果长效留存",
    quickly:
      "超短链活性肽可将富氧血液输送至阴茎海绵体，改善勃起反应迟缓、充盈不足等问题，瞬间唤醒身体原生活力；加速血液循环，提升肌体坚挺度，带来舒适的身体状态。晨间生理活力逐步恢复，堆积的疲惫与周身不适感慢慢消散，重拾久违的饱满体感，即刻找回自信。",
    supporting:
      "配方持续清除体内氧化自由基，改善身体敏感度过高、体能孱弱问题，大幅提升耐力耐受阈值；可维持30分钟以上平稳舒缓的身体状态，全程精力充沛无乏力回落。同时改善多梦、睡眠质量差、周身困倦、腰酸体虚等各类亚健康困扰，整日元气在线，状态稳定从容，享受舒适调养体验。",
    maintain:
      "产品靶向修护MDM4关键机能基因，激活受损性腺受体，搭配珍贵植萃深层固本滋养；稳固90°挺立状态，全方位优化坚挺度、续航力、饱满度三大核心维度。停用后调养成果依旧可以长效维系，稳固男性巅峰身心活力，状态持久可靠。",
    Sustain: "迸发巅峰效能 · 持久维系男性元气活力",
    tissues:
      "小分子活性肽可直达性腺组织，既能即刻滋养肌体，又能激活内源基因活力、实现长效养护。服用首日便可感受到精力状态提升，滋养调理效果可长效维系两周，全方位调养身体亚健康状态。配方无外源激素添加，依托天然生物活性肽唤醒身体原生元气，稳固男性健康生理活力。",
    Improvements: "初期体感改善",
    Activation: "持续活力唤醒",
    Repair: "全身机能修护",
    Stabilization: "深层生理稳固",
    Remodeling: "男性生理机能重塑",

    Improvementsss: "服用第1天 | 初期直观改善",
    Activationss: "连续服用2周 | 持续激活肌体活力",
    Repairss: "连续服用4周 | 全方位肌体调养修护",
    Stabilizationss: "连续服用60天 | 深层生理状态稳固",
    Remodelingss: "连续服用180天 | 男性生理机能重塑",

    significant:
      "92.7%试用人群海绵体充血量显著提升，快速改善勃起疲软、起立无力问题；晨间生理活力逐步恢复，即刻收获坚挺状态。85.2%人群身体敏感度适度回落，体能续航时长提升约10%。",
    increase:
      "93.9%人群充血能力大幅提升，坚挺质感明显优化；89.4%人群敏感度回归平稳区间，耐受阈值显著拉高，可平稳维持20分钟以上理想状态。同时可改善失眠多梦、体虚乏力问题，整日精力充沛。",
    weeks:
      "95.2%人群可稳固维持90°挺立状态，92.8%人群敏感度调控平稳，体能续航可达30分钟以上；性腺细胞充盈度持续维持高位，短期停用调养效果不易回落，全身元气与精力大幅提升。",
    stabilized:
      "97.1%人群MDM4机能基因修护趋近完成，性腺原生活力自主再生，无需持续依靠产品加持；腰膝酸软、体虚气短等亚健康问题彻底改善。身体内源动力可自主维系，坚挺度、耐力持久平稳无起伏。",
    months:
      "98.6%人群生殖内分泌系统达成健康平衡，性腺细胞活力长久存续；即便长期间断停用，勃起充盈度、身体耐受度依旧保持巅峰水准，彻底解决机能衰退困扰，实现男性生理状态长效稳定。",
    tested: "上万用户实测验证",
    lasting: "巅峰体能 · 长效持久活力",
    Institute:
      "美国ECOSUPER研究院携手约翰·霍普金斯大学以及亥姆霍兹医学研究所，开展多中心人体临床试验，筛选1826名28至55岁男性参与测试，最终1500人完成为期28天的完整试验疗程。分别于第1天、2周、4周、60天、180天全程采集记录各项生理数据，持续监测身体指标，全程未产生肝肾损伤、激素依赖等副作用。对比普通单方滋补产品，该产品从硬度、坚挺度、持久度三大维度完成全面升级，各方面均获得明显改善。",
    proportion: "提升比例",
  },
  detail: {
    Verification: "全球公认 · 权威认证核验",
    Authority: "媒体与学术权威背书",
    academic:
      "SUPER十倍超肽精粹X10 荣获全球知名学术平台、专业医疗媒体双重认证；历经严苛全方位科学验证，临床试验数据全程公开透明，树立男性活性肽领域科研标杆。",
    evidence: "医学文献佐证",
    clinical: "权威临床实测数据",
    consensus: "全球学界共识",
    technology: "前沿基因修护技术",
    verified:
      "生物医学临床试验证实：本品核心活性调节因子可逆转MDM4机能基因衰退，改善男性生理机能衰弱相关问题。",
    arterial:
      "使用后阴茎动脉血流量提升53%~61%，国际勃起功能指数（IIEF）平均分提升42%。",
    platforms:
      "配方核心活性肽突破传统调养方式局限，在男科泌尿临床领域具备不可替代的应用价值。",
    Global: "全球用户真实口碑见证",
    Widely:
      "收获全球肽类科研专家、行业权威一致认可，SUPER十倍超肽X10填补MDM4靶向基因修护领域科研空白，打破过往仅依靠化学制剂调理男性肌体活力的传统模式。",
    Pioneer: "引领全球泌尿健康科研新趋势",
    recommendation: "世界各地用户自发好评推荐",

    French: "法国消费者",
    US: "美国消费者",
    Italian: "意大利消费者",
    Korean: "韩国消费者",
    Japanese: "日本消费者",
    Finnish: "芬兰消费者",
    Thai: "泰国消费者",
    Australian: "澳大利亚消费者",
    Zealand: "新西兰消费者",

    Je: "我强烈推荐这款产品给男士，它能让家庭生活更加和睦美满。",
    JVi: "降压人群无法服用传统药物，这款产品给了我全新的改善希望。",
    Invece: "不必辛苦锻炼，选择这款产品即可；身体不易疲惫，调养效果更佳。",
    SUPER: "SUPER超肽X10彻底改变了我的生活状态。",
    Peptide:
      "由衷感谢SUPER超肽X10。此前我长期受男性生理机能衰退困扰，这款产品为我重拾希望，愿更多人可以受益于这款优质好物。",
    review:
      "对比多年泌尿调养方案，SUPER超肽X10带来的体验是过往所有产品都无法比拟的，非常值得一试。",
    ksjsjs: "夜间店铺爆款好物，还没体验过真的太可惜了。",
    This: "男士健康专科诊所医生向我推荐的产品，调养效果格外出色。",
    Ever: "坚持服用SUPER超肽X10之后，我的身心自信提升了许多。",
    Thiss: "这款产品调养效果绝佳，体验过后一定会倍感惊喜，放心入手。",
    Endorsement: "专家与权威人士联合背书",
    authoritative:
      "产品获得全球肽类科研专家、行业权威广泛认可；SUPER十倍超肽X10填补MDM4靶向基因修护技术空白，革新了以往单纯依靠化学制剂调养男性生理机能的传统方式。",
    verification: "专业专家实操验证",
    Paul: "保罗·J·图雷克 医学博士，美国外科学院院士",
    Raju: "拉朱·托马斯 医学博士，美国外科学院院士",
    Past: "SMRU前任主席（2013届任期）",
    Senior: "2016年美国生殖医学学会学术委员会高级顾问",
    American: "美国泌尿协会（AUA）",
    Recipient: "2016年度美国泌尿协会杰出服务奖获得者",
    Director: "泌尿护理基金会负责人",
    Expert:
      "专家评述：十余年来，ECOSUPER汇聚全球顶尖泌尿、男科领域专家学者，在三大核心研究方向取得里程碑式科研成果：改善中老年男性肌体机能衰退、修复私处血液灌注能力、营养调控睾酮内分泌平衡，科研实力雄厚，极具角逐诺贝尔生理学或医学奖的潜力。",
    Comment:
      "专家评述：全球数十万可重复临床试验数据充分证实：SUPER超肽X10融合小分子活性肽、靶向基因调控、组织再生三大前沿科研技术，可显著提升私处动脉血流量，稳步提升国际勃起功能指数（IIEF）评分，攻克了男性勃起组织退行性损伤这一长久以来的临床难题。",
    Journals: "权威顶尖学术期刊科研佐证",
    Nature: "《自然综述·泌尿学》",
    From: "从基因修护到肌体组织再生",
    Top: "泌尿领域顶刊综述期刊，收录行业权威共识、前沿分子作用机理以及营养肽类转化医学研究成果。",
    Restoration:
      "SUPER超肽X10精准靶向修护男性核心机能基因MDM4，开启泌尿生殖系统修护全新纪元",
    Journal: "《性医学期刊》(JSM)",
    Official:
      "国际SMSNA官方期刊：全球勃起功能、私处血流动力学、IIEF评分评估、口服肽制剂临床试验核心发布平台，本品血流改善临床试验数据已刊载于此刊。",
    Development:
      "基于核心机能基因MDM4调控+血管弹性指标构建的勃起问题调养干预体系研究",
    Evidence: "SUPER超肽X10改善生理机能衰退干预效果循证分级研究",
    Test: "依托IIEF评分体系实测本品私处动脉血流量提升数据报告",
    Randomized:
      "随机双盲对照临床试验：本品改善年龄相关激素水平下降及连带生理机能衰退效果研究",
    regulate:
      "本品核心活性调节因子可逆转MDM4机能基因衰退，改善男性生理机能衰弱相关问题。",
    Honors: "权威荣誉与资质认证",
    SUPER1:
      "SUPER十倍超肽X10斩获多家国际权威机构认证。依托前沿科研配方、严苛全链路品控体系与优异的身体调养效果，收获全球各大专业机构多项荣誉认可与资质背书。",
    International: "国际权威行业大奖",
    Rigorous: "严苛品质管控 + 官方权威资质认证",
    Winner: "美国泌尿协会AUA 创新产品大奖得主",
    Winner2: "国际生物科技创新组织 生物科技突破大奖",
    Winner3: "欧洲泌尿学会EAU 泌尿健康创新产品大奖",
    Winner4: "欧洲泌尿学会EAU 前列腺健康专项研究大奖",
    Product: "产品设计大奖：德国汉诺威iF国际设计论坛 iF设计奖",
    Product1: "产品设计大奖：国际卓越设计协会 IDEA设计大奖",
    Product2: "产品设计大奖：德国红点设计协会 红点产品设计大奖",
    Winner5: "年度创新产品大奖，VB100未来医疗百强榜单入选产品（思宇医疗科技）",
  },
  sec: {
    Trial: "免费试用体验",
    box: "可领取1盒试用装",
    satisfied: "体验不满意，支持全额退款",
    Questions: "常见问题答疑",
    product:
      "本品甄选牡蛎肽、玛咖粉、海参肽、树莓等9种天然动植物精粹调配而成，配方温和纯粹，无有害添加。人体营养吸收速率因人而异，坚持长期调养可收获更佳身心状态。",
    guidance: "专属客服一对一提供服用剂量指导方案",
    fatigue: "适用30周岁以上成年男性；针对体虚易乏、精力不足、亚健康人群调养",
    hormones:
      "原料天然占比高达99.9%，不含人工合成激素、类固醇及化工添加剂；温和无刺激、不会产生依赖，依托人体自身机理循序渐进调养，稳固肌体耐力与身心活力，由内而外改善身体状态。",
    Packing: "私密隐私打包",
    delivery: "包裹无任何敏感字样，全程保密配送",
    Policy: "退换货售后政策",
    Period: "1. 申请时效：",
    parcels: "签收包裹15天内，联系客服提交售后申请",
    cases: "2. 售后适用场景：",
    items: "物流磕碰破损、液体渗漏、外包装损毁、错发漏发商品",
    Rules: "售后流程与细则规范",
    waiting:
      "售后审核通过后，商品寄回本地仓核验；核验完成当日即可发出全新替换货品，无需漫长跨境等待",
    Limit: "1. 换货次数限制：",
    exchange: "每笔订单可享受1次免费换货服务",
    Shipping: "2. 运费承担规则：",
    returns:
      "商品质量、商家错漏发问题，所有运费由商家承担；非质量问题退换货，需买家自行承担本地寄回运费",
 improvements: '多久可以感受到改善效果？',
Dosage: '每日服用剂量',
Crowd: '适用人群',
addictive: '是否会产生依赖性？',
experience: '对个人使用效果不满意',
consumption: '个人想要停止使用产品',
resellable: '温馨提醒：退回货品须完好，可供再次销售',
Policy: '全额退款政策'
    },
    user: {
  Selection: "套餐选择",
  Selection1: "全球官方零售价",
  Now: "立即购买",
  Basic: "基础套餐",
  Starter: "入门套餐",
  Standard: "标准套餐",
  Cycle: "周期套餐",
  Box: "1盒正装",
  Box1: "2盒正装",
  Box2: "4盒正装",
  Box3: "6盒正装",
  shipping: "（运费过高，不建议选购）",
  Items: "购物车清单",
  Information: "订单收货信息",
  First: "名字",
  Last: "姓氏",
  Phone: "联系电话",
  Address: "收货地址1",
  Address1: "收货地址2",
  City: "城市",
  State: "省份：",
  Zip: "邮政编码：",
  Country: "国家：",
  Email: "邮箱",
  Notes: "订单备注/配送说明",
  back: "返回",
  Submit: "提交订单",
  message1: "请填写名字",
  message2: "请填写姓氏",
  message3: "请填写详细地址",
  message4: "请填写城市",
  message5: "请填写省份",
  message6: "请填写邮编",
  message7: "请选择国家",
  message8: "请填写手机号",
  message9: "请请填写邮箱",
  message10: "邮箱格式不正确",
  Malaysia:'马来西亚',
Singapore:'新加坡',
 contact: '如需查询订单物流以及售后相关事宜，请联系您的专属顾问。',
    order: '感谢您的下单！'
}
};
